import { MdOutlineCancel } from "react-icons/md";
import { PiWarning } from "react-icons/pi";
import { FaRegCheckCircle } from "react-icons/fa";
import { FiInfo } from "react-icons/fi";
import Button from "../button/button";
import "./popup.scss";

const Popup = ({
    type,
    alertType = "default", // Puede ser "error", "warning", "success", "information"
    titleMessage,
    alertMessage,
    onConfirm,
    onClose,
    children,
    confirmLabel = "Confirmar",
    cancelLabel = "Cancelar",
    closeLabel = "Cerrar",
    size = "default", // "default" o "XL"
}) => {
    const getIconByType = () => {
        switch (alertType) {
            case "error":
                return <MdOutlineCancel className="popup__title__icon" />;
            case "warning":
                return <PiWarning className="popup__title__icon" />;
            case "success":
                return <FaRegCheckCircle className="popup__title__icon" />;
            case "information":
                return <FiInfo className="popup__title__icon" />;
            default:
                return "";
        }
    };

    return (
        <div className="popup-overlay">
            <div
                className={`popup ${type} ${alertType} ${
                    size === "XL" ? "popup--xl" : ""
                }`}
            >
                <div className="popup__title">
                    {type === "alert" && (
                        <>
                            {getIconByType()}
                            <h2 className="popup__title__text">
                                {titleMessage}
                            </h2>
                        </>
                    )}
                    {type === "info" && (
                        <h2 className="popup__title__text">{titleMessage}</h2>
                    )}
                </div>
                <div className="popup__content">
                    {type === "alert" ? (
                        <p className="popup__content__message">
                            {alertMessage}
                        </p>
                    ) : (
                        children
                    )}
                </div>
                <div className="popup__actions">
                    <Button
                        label={confirmLabel}
                        onClick={onConfirm}
                        variant="filled"
                        fullWidth="width-100"
                        statusType={alertType === "error" ? "error" : "default"}
                    />

                    <Button
                        label={type === "alert" ? cancelLabel : closeLabel}
                        onClick={onClose}
                        variant="outline"
                        fullWidth="width-100"
                    />
                </div>
            </div>
        </div>
    );
};

export default Popup;
